class YoutubeModal {
  constructor(el, opt) {
    this.el = el;
    if ($("." + this.el).length > 0) {
      this.event();
    }
  }
  event() {
    function youtube_modal(trigger) {
      $(trigger).modaal({
        type: "video",
      });
    }
    youtube_modal(".js-video-open");
  }
}